<template>
    <div class="main">
        <div class="model_content">
            <div class="text">消费者扫码地址</div>
            <div class="title">
                <h2>
                    <!-- <label v-if="option.modelTitle">{{option.modelTitle}}</label>  -->
                </h2>
                <!-- <img @click="hideModel" src="../assets/close_icon.png" alt=""> -->
                <i @click="hideModel" class="el-icon-close"></i>

            </div>
            <div class="map_box">
                <!-- <div class="bm-view" id="container">
                    <el-amap vid="amapDemo" zoom="14" :center="center">
                        <el-amap-marker animation="AMAP_ANIMATION_BOUNCE" :position="center"></el-amap-marker></el-amap>
                </div> -->
                <baidu-map class="bm-view" :zoom="14" :center='center' :scroll-wheel-zoom="false">
                    <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
                        anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
                    <bm-marker :position="markerPo" :dragging="false" animation="BMAP_ANIMATION_BOUNCE">
                    </bm-marker>
                </baidu-map>
            </div>
        </div>
    </div>
</template>
<script>
// import BmMarker from "vue-baidu-map/components/overlays/Marker"; //点标注
export default {
    data: () => {
        return {
            isShow: false,
            center: {},
            // center: [],
            markerPo: {},
            map: null,
            // iconPoint: require('../assets/niu.jpg')
        }
    },
    components: {
        // BmMarker,
    },
    props: {
        option: Object
    },
    created() {
        this.center = {
            lng: this.option.latitude,
            lat: this.option.longitude
        }
        this.markerPo = this.center;
    },
    watch: {
        // option() {
        // const location = {
        //     // lng: this.option.lng,
        //     // lat: this.option.lat
        //     lng: this.option.latitude,
        //     lat: this.option.longitude
        // }
        // // this.center = [location.lng, location.lat];
        // this.markerPo = location;
        // }
    },
    mounted() {

        // this.center = [this.option.latitude, this.option.longitude]
        // this.$nextTick(() => {
        //     this.initAMap()
        // })
    },
    methods: {
        showModel() {
            // this.isShow = true;
            this.NoScrolling()
        },
        hideModel() {
            // this.isShow = false;
            this.scrolling()
            this.$emit('closePichMap')
        },
        // initAMap() {
        //     AMapLoader.load({
        //         key: '5a0c1eeb3c3665e4e06c3855b5688a1a',  //设置您的key
        //         version: "2.0",
        //         plugins: ['AMap.ToolBar', 'AMap.Driving'],
        //         AMapUI: {
        //             version: "1.1",
        //             plugins: [],

        //         },
        //         Loca: {
        //             version: "2.0"
        //         },
        //     }).then((AMap) => {
        //         this.map = new AMap.Map("container", {
        //             viewMode: "2D",
        //             resizeEnable: true,
        //             zoom: 18,
        //             zooms: [2, 22],
        //             center: this.center,
        //         });
        //         this.map.setDefaultCursor('pointer');
        //         // 设置位置的标记
        //         this.setMapMarker(AMap)
        //     }).catch(e => {
        //         console.log(e);
        //     })
        // },
        // setMapMarker(AMap) {
        //     console.log(AMap, '34343');
        //     //     const icon = new window.AMap.Icon({
        //     //         size: new window.AMap.Size(36, 36),//图标尺寸
        //     //         image: this.iconPoint,
        //     //         imageSize: new window.AMap.Size(36, 36),//根据所设置大小拉伸或者压缩图片
        //     //     })
        //     var labelOffset = new window.AMap.Pixel(0, -5);
        //     // 借助require函数提前加载到图片
        //     // var markerContent = ' <img src="' + this.iconPoint + '" alt="" />'

        //     var marker = new AMap.Marker({
        //         map: this.map,
        //         position: this.center,
        //         // icon: icon,
        //         anchor: 'center', //设置锚点
        //         // content: markerContent,
        //         offset: new window.AMap.Pixel(0, 0), //设置偏移量
        //         label: {
        //             direction: 'top',
        //             // content: labelContent,
        //             offset: labelOffset,
        //         },
        //         // 设置是否可拖拽
        //         // draggable: true,
        //         // cursor: 'pointer'
        //     })
        //     marker.setMap(this.map);
        //     //标注点弹跳动画
        //     marker.setAnimation('AMAP_ANIMATION_BOUNCE')
        //     // 将 markers 添加到地图
        //     // this.markers.push(marker)
        // },
    }
}
</script>
<style lang="scss" scoped>
.main {
    /* width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0; */
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 1);
    z-index: 2;

    .model_content {
        position: relative;
        // top: -1rem;
        // top: -10%;
        // left: 50%;
        // transform: translate(-50%, -50%);
        width: 21.62rem;
        max-height: 11.18rem;
        // height: calc(100vh - 50px);
        // background: rgba(7, 70, 73, 0.95);
        // box-shadow: 0rem 0.03rem 0.28rem 0rem rgba(47, 244, 225, 0.5), inset 0rem 0.01rem 0.06rem 0rem #08DAC8;
        // border: 0.03rem solid #01FAFF;
        background: url('../assets/map_bg.png');
        background-size: 100% 100%;
        padding: 0.3rem .88rem;

        .text {
            position: absolute;
            top: 2%;
            // left: 7rem;
            left: 45%;
            font-size: 0.3rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #032929;
        }

        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .el-icon-close {
                // position: absolute;
                // right: 0.38rem;
                // top: 0.25rem;
                font-size: .4rem;
                color: #00E0DB;
                cursor: pointer;
                margin-right: -0.55rem;
            }

            img {
                width: 0.28rem;
                height: 0.28rem;
                cursor: pointer;
            }
        }

        .map_box {
            display: flex;
            justify-content: center;
        }

        .bm-view {
            margin-top: 0.4rem;
            width: 100%;
            height: 9.46rem;

            ::v-deep .BMap_cpyCtrl {
                display: none !important;
            }
        }
    }

}
</style>